import {
  LIST_USER_PARTNER_REQUEST,
  LIST_USER_PARTNER_SUCCESS,
  LIST_USER_PARTNER_FAIL,
  CREATE_USER_PARTNER_REQUEST,
  CREATE_USER_PARTNER_SUCCESS,
  CREATE_USER_PARTNER_FAIL,
  DETAIL_USER_PARTNER_REQUEST,
  DETAIL_USER_PARTNER_SUCCESS,
  DETAIL_USER_PARTNER_FAIL,
  UPDATE_USER_PARTNER_REQUEST,
  UPDATE_USER_PARTNER_SUCCESS,
  UPDATE_USER_PARTNER_FAIL,
  DELETE_USER_PARTNER_REQUEST,
  DELETE_USER_PARTNER_SUCCESS,
  DELETE_USER_PARTNER_FAIL,
  USER_PARTNER_RESET
} from '../../constants/users'

const initialState = {
  loading: false,
  loadingDetail: false,
  loadingUpdate: false,
  usersPartner: [],
  userPartner: {},
  error: null,
  status: '',
  message: '',
  pageable: {}
}

const usersPartnerReducer = (state = initialState, action) => {
  switch (action.type) {
    // Partner
    case LIST_USER_PARTNER_REQUEST:
      return { ...state, loading: true }
    case LIST_USER_PARTNER_SUCCESS:
      return { ...state, loading: false, usersPartner: action.payload, pageable: action.pageable }
    case LIST_USER_PARTNER_FAIL:
      return { ...state, loading: false, error: action.payload, usersPartner: [] }
    case USER_PARTNER_RESET:
      return { usersPartner: [] }
    case DETAIL_USER_PARTNER_REQUEST:
      return { ...state, loadingDetail: true, userPartner: {} }
    case DETAIL_USER_PARTNER_SUCCESS:
      return { ...state, loadingDetail: false, userPartner: action.payload }
    case DETAIL_USER_PARTNER_FAIL:
      return { ...state, loadingDetail: false, error: action.payload }
    case CREATE_USER_PARTNER_REQUEST:
      return { ...state, loading: true }
    case CREATE_USER_PARTNER_SUCCESS:
      const newUserPartner = action.payload
      return { ...state, loading: false, success: true, usersPartner: [...state.usersPartner, newUserPartner] }
    case CREATE_USER_PARTNER_FAIL:
      return { ...state, loading: false, error: action.payload }
    case UPDATE_USER_PARTNER_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_USER_PARTNER_SUCCESS:
      const usersPartnerData = [...state?.usersPartner]
      const indexPartner = usersPartnerData.findIndex(user => user.id === action.payload.id)
      usersPartnerData[indexPartner] = action.payload

      return { ...state, loadingUpdate: false, success: true, usersPartner: usersPartnerData }
    case UPDATE_USER_PARTNER_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_USER_PARTNER_REQUEST:
      return { ...state, loading: true }
    case DELETE_USER_PARTNER_SUCCESS:
      return { ...state, loading: false, success: true }
    case DELETE_USER_PARTNER_FAIL:
      return { ...state, loading: false, error: action.payload }
    default:
      return state
  }
}

export default usersPartnerReducer
